// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1RwIz","large":"styles_large__-FVIL"};